// import cookies from 'js-cookie'
import storage from 'good-storage'

const LoginStatusKey = 'Login-Status'     //登录态 0 1 2

const LoginPcStatus = 'LoginPc-Status'

export function loadLoginStatus () {
  return storage.session.get(LoginStatusKey) || 0
}

export function saveLoginStatus (status) {
  storage.session.set(LoginStatusKey, status)
  return status
}

export function loadLoginPcStatus () {
  return storage.session.get(LoginPcStatus) || false
}

export function saveLoginPcStatus (success) {
  storage.session.set(LoginPcStatus, success)
  return success
}

export function loadUserInfo () {
  return storage.session.get('shengyaUser', {})
}

export function saveUserInfo (userInfo) {
  storage.session.set('shengyaUser', userInfo)
  return userInfo
}

export function loadArrCosPlay () {
  return storage.session.get('arrCosPlay', ['0','0','0','0','0','0','0','0','0','0','0','0','0'])
}

export function saveArrCosPlay (arrCosPlay) {
  storage.session.set('arrCosPlay', arrCosPlay)
  return arrCosPlay
}

export function loadArrCosAward () {
  return storage.session.get('arrCosAward', ['0','0','0'])
}

export function saveArrCosAward (arrCosAward) {
  storage.session.set('arrCosAward', arrCosAward)
  return arrCosAward
}